var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-modal',_vm._g({ref:"forkSuggestionModal",attrs:{"modal-id":"fork-suggestion-modal","no-focus-on-show":"","visible":_vm.visible,"title":_vm.__('Fork to make changes'),"action-primary":_vm.primaryAction,"action-secondary":_vm.secondaryAction}},_vm.$listeners),[_c('p',{attrs:{"data-testid":"message"}},[_vm._v("\n    "+_vm._s(_vm.__(
        "You're not allowed to make changes to this project directly. Create a fork to make changes and submit a merge request.",
      ))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }